import { schema } from "normalizr";

const labels = new schema.Entity("labels");

const Schemas = {
    LABELS_ARRAY: { data: [labels] }
};

export default Schemas;
